module.exports = __webpack_public_path__ + "static/media/max3d.507517a6.png";